module.exports = __webpack_public_path__ + "static/media/jwtSignature.a4be9c6b.png";